module.exports = __webpack_public_path__ + "img/left-triangle.d10cae5a.svg";